module.exports = __webpack_public_path__ + "img/Halle_Leer 009.3faeb0e3.jpg";